import {FormElement} from "./form-element.js";
import {OptionTools} from "./option-tools.js";
import {CheckElement} from "./check-element.js";

/**
 * Represents a multi-select form element that allows selection of multiple options.
 * This class extends the FormElement base class and provides functionality for rendering
 * and managing a group of checkable options.
 */
export class MultiSelectElement extends FormElement {
    options;
    noValue = false;

    constructor(formData, parentElement, collection) {
        super(formData, parentElement, collection);
    }

    /**
     * Sets the label for the specified wrapper by prepending a generated component label.
     *
     * @param {HTMLElement} wrapper - The wrapper element to which the label is added.
     * @param {Object} component - The component associated with the label.
     * @return {void} This method does not return a value.
     */
    setLabel(wrapper, component) {
        wrapper.prepend(this.componentLabel());
    }

    /**
     * Adds a class to the provided wrapper element and renders a collection of check elements based on the given options.
     *
     * @param {HTMLElement} wrapper - The HTML element that will serve as the container for the rendered components.
     * @return {null} Always returns null after rendering the components.
     */
    component(wrapper) {
        wrapper.classList.add('multi-select-group');

        const options = OptionTools.buildOptions(this, this.options, this.formData);
        options.forEach(option => {
            const check = Object.assign(new CheckElement(this.formData, wrapper, this.collection), option);
            check.parent = this;
            check.render();
        });

        return null;
    }
}
